<template>
    <div class="row">
        <div class="col-12">
            <div class="breadcrumb" v-if="$store.state.trajectory.trajectory.id">
                <router-link :to="{ name: 'dashboard', param: {id: $store.state.trajectory.trajectory.id} }">
                    <i class="icons icon-arrow-left"></i> {{$t('common.back_last_trajectory')}}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';

    @Component
    export default class BackToLastTrajectory extends Vue {}
</script>



// WEBPACK FOOTER //
// src/components/general/BackToLastTrajectory.vue